import ofertaCGU from "@/config/brands/ofertaCGU";

describe("ofertaCGU config", () => {
  it("configuracion exportada por defecto", () => {
    expect(ofertaCGU).toBeDefined();
    expect(ofertaCGU).not.toBeNull();
  });
});
